module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-377.bf3e983.woff2";